<template>
	<div style="display: flex;justify-content: ;">
		<router-view></router-view>
		<div class="body-right">
			<div @click="dialogVisible = true">
				<img src='../../../assets/images/zhifly.png' alt="" style="width: 18px;height: 18px;"><span
					style="width:80px">发布</span>
			</div>
			<div style="background: #18BC9C;" @click="goto(`/userCenter/drafts`)">
				<img src='../../../assets/images/caogao.png' alt="" style="width: 19px;height: 19px;"><span
					style="width:80px">草稿箱</span>
			</div>
			<div style="background:#0297F8;" @click="dialogVisible2 = true">
				<img src='../../../assets/images/dwen.png' alt="" style="width: 19px;height: 19px;"><span
					style="width:80px">求助</span>
			</div>
			<div style="background:#444C69;"  @click="goto(`/userCenter/pthd/myMessage?type=${2}`)">
				<img src='../../../assets/images/iicon.png' alt="" style="width: 18px;height: 16px;"><span
					style="width:80px">@我的</span>
			</div>
			<div style="background:#E5F2FF; color: black;"  @click="goto(`/userCenter/pthd/myMessage?type=${1}`)">
				<img src='../../../assets/images/xiaoxxi.png' alt="" style="width: 18px;height: 16px;"><span
					style="width:80px">我的消息</span>
			</div>
		</div>
		<el-dialog title="请选择栏目" :visible.sync="dialogVisible" center width="700px" top="40vh" :lock-scroll="false">
			<div style="display:flex;justify-content: space-around;font-size: 18px;color: black;">
				<div @click="goto(`/projectNeed/releaseNeed`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					项目需求池
				</div>
				<div @click="goto(`/zyTools/createTools`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					资源工具池
				</div>
				<div @click="goto(`/solutionDetail/releaseSolution`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					解决方案池
				</div>
				<div @click="goto(`/productService/createProductService`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height:47px;text-align: center;cursor: pointer;">
					产品服务池
				</div>
			</div>
		
		</el-dialog>
		<el-dialog title="请选择栏目" :visible.sync="dialogVisible2" center width="700px" top="40vh" :lock-scroll="false">
			<div style="display:flex;justify-content: space-around;font-size: 18px;color: black;">
				<div @click="goto(`/zyTools/createTools`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					资源工具池
				</div>
				<div @click="goto(`/solutionDetail/createQz`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					解决方案池
				</div>
				<div @click="goto(`/productService/proCreateQz`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height:47px;text-align: center;cursor: pointer;">
					产品服务池
				</div>
			</div>
		
		</el-dialog>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				dialogVisible: false,
				dialogVisible2: false,
			}
		},
		methods:{
			goto(url) {
				this.$router.push(url)
			},
		}
	}
</script>

<style lang="less" scoped>
	.body-right {
		&>div {
			cursor: pointer;
			margin-bottom: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			line-height: 50px;
			width: 200px;
			height: 50px;
			background: #0052D9;
	
			&>img {
				margin-right: 15px;
			}
		}
	}
</style>